import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type {
  GetDocumentsParams,
  GetDocumentsResult,
} from '../../api/get-documents/getDocuments.types';

import { getDocuments } from '../../api/get-documents/getDocuments';

export function useDocuments(
  params: GetDocumentsParams
): UseQueryResult<GetDocumentsResult, Error> {
  const queryKey = [
    'documents',
    params.documentType,
    params.organizationId ?? null,
    params.folderId ?? null,
    params.searchText ?? null,
  ];

  return useQuery<GetDocumentsResult, Error>({
    queryKey,
    queryFn: (): Promise<GetDocumentsResult> => getDocuments(params),
    enabled:
      !!params.documentType &&
      (params.documentType !== 'Customer' || !!params.organizationId),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
